import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Tag } from '@components/core-ui/Tag';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto, JobsService } from 'app/API';
import React from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Input } from '@components/core-ui/form-elements/Input';
import { Content } from './EditJobTagsModal/styles/Content';
import { Tags } from './EditJobTagsModal/styles/Tags';

type TProps = {
  job: JobResponseDto;
  onCancel: () => void;
  onSuccess: () => void;
};

export const EditJobTagsModal = ({ job, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { workspace } = useAuthContext();
  const [tags, setTags] = React.useState(job.tags ?? []);

  const handleSubmit = async () => {
    const workspaceId = job.workspaceId ?? workspace?.id ?? '';
    await call(
      JobsService.editJobTags({
        wsid: workspaceId,
        jobId: job.id,
        requestBody: { tags: tags.join(',').replace(/\s/g, '_').split(',') },
      }),
    );
    onSuccess();
  };

  const onChange = async (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    setTags(value.split(','));
  };

  const deleteTag = async (tag: string) => {
    setTags(tags.filter((t: string) => t !== tag));
  };

  const tagsValue = (tags ?? []).join(',').replace(/\s/g, '_');
  const tagsArray = (tags ?? []).filter((tag: string) => !!tag);

  return (
    <ModalWrapper width="487px">
      <ModalTitle>Edit Job Tags</ModalTitle>
      <Content>
        <Input
          name="tags"
          label="Add tags..."
          value={tagsValue}
          disabled={!job}
          onChange={onChange}
          required={false}
          className="form-input w-full"
        />
        {tagsArray.length ? (
          <Tags>
            {tagsArray.map((tag: string, index: number) => (
              <Tag key={index} onDelete={() => deleteTag(tag)}>
                {tag.replace(/\s/g, '_')}
              </Tag>
            ))}
          </Tags>
        ) : null}

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
